import { idType } from '@src/types';
import { ModalType } from '@uikit/Modal/modals/constants';

export type TableProps = {
  page?: number;
  size?: number;
  rows?: any;
  scrollToTopOnDataChange?: boolean;
  handleUpdatePermission?: (params: {
    permissionId: number | undefined;
    abilityId: number;
    status: boolean;
  }) => void;
  arrowIconMember?: boolean;
  isLoading?: boolean;
  onEditClick?: (id: idType) => void;
  onAuditClick?: (
    id: idType,
    modalName: ModalType,
    tableName: string | undefined
  ) => void;
  onImageClick?: (img: string, title: string) => void;
  onCheckboxClick?: (id: idType, name: string, checked: boolean) => void;
  onPageChange?: (newPage: number) => void;
  currentPage?: number;
  className?: string;
  abilities?: string[] | undefined;
  activeRowId?: idType;
  handleSelectedRow?: (id: idType) => any;
  handleDeleteRow?: (id: idType) => any;
  onFieldClick?: (row: any, field?: string) => void;
  totalPages?: number;
  totalElements?: number;
  columns?: any;
  requestTablePageChange?: any;
  path?: string;
  openModal?: (type, id) => void;
  table?: string;
  tableCustomClassName?: string;
  tableTitle?: string;
  columnsSorting?: any;
  sortingTable?: any;
  setSortingTable?: any;
  tableName?: string;
  modalName?: ModalType;
  hasPagination?: boolean;
  method?: string;
  argument?: any;
  params?: any;
  skeletonProps?: any;
  tableIsBig?: boolean;
  statusSetter?: (id: idType, value: boolean) => void;
  scrollThreshold?: number;
  dataTestId?: string;
};

export enum PermissionsEnum {
  Read = 1,
  Create = 2,
  Edit = 3,
  Audit = 4,
  Special = 5,
}

export type CustomTableProps<TOnUpdate = unknown> = {
  page?: number;
  size?: number;
  rows?: any;
  scrollToTopOnDataChange?: boolean;
  onUpdate?: (params: TOnUpdate) => void;
  arrowIconMember?: boolean;
  isLoading?: boolean;
  onEditClick?: (id: idType) => void;
  onAuditClick?: (
    id: idType,
    modalName: ModalType,
    tableName: string | undefined
  ) => void;
  onImageClick?: (img: string, title: string) => void;
  onCheckboxClick?: (id: idType, name: string, checked: boolean) => void;
  onPageChange?: (newPage: number) => void;
  currentPage?: number;
  className?: string;
  abilities: string[];
  activeRowId?: idType;
  handleSelectedRow?: (id: idType) => any;
  handleDeleteRow?: (id: idType) => any;
  onFieldClick?: (row: any, field?: string) => void;
  totalPages?: number;
  totalElements?: number;
  columns?: any;
  requestTablePageChange?: any;
  path?: string;
  openModal?: (type: any, id: any) => void;
  table?: string;
  emptyText?: string;
  tableCustomClassName?: string;
  tableTitle?: string;
  columnsSorting?: any;
  sortingTable?: any;
  setSortingTable?: any;
  tableName?: string;
  modalName?: ModalType;
  hasPagination?: boolean;
  method?: string;
  argument?: any;
  params?: any;
  skeletonProps?: any;
  tableIsBig?: boolean;
  statusSetter?: (id: idType, value: boolean) => void;
  scrollThreshold?: number;
  dataTestId?: string;
};
